/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=2c647924&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../../assets/scss/new3D_index.scss?vue&type=style&index=0&id=2c647924&scoped=true&lang=scss&external"
import "./index.vue?vue&type=style&index=1&id=2c647924&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c647924"]])

export default __exports__